var v1="<div class=\"range\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <input type=\"range\" step=\"{{vm.step}}\" min=\"{{vm.min}}\" max=\"{{vm.max}}\" ng-model=\"vm.rangeModel\" ng-change=\"vm.updateModel()\" name=\"{{ vm.settings.dataAt }}\" id=\"{{ vm.settings.dataAt }}\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\"> <p>Value: {{ vm.rangeModel }} {{ vm.units }}</p> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaRange/lbaRange.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaRange/lbaRange.html
// module id = 301
// module chunks = 0